var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVl2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 273.649,
    height: 231.538,
    viewBox: "0 0 273.649 231.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(-14.416 -51.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(97.014 76.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(6.357 21.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M170.322,157.165h0a.262.262,0,0,1-.228-.131l-2.48-4.293a.26.26,0,0,1,0-.263l2.48-4.293a.262.262,0,0,1,.228-.131h0a.261.261,0,0,1,.227.131l2.486,4.293a.262.262,0,0,1,0,.264l-2.486,4.293A.262.262,0,0,1,170.322,157.165Zm-2.177-4.556,2.177,3.768,2.181-3.768-2.181-3.767Z",
    transform: "translate(-167.578 -148.054)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    transform: "translate(0.706 22.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M159.346,152.724a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,159.346,152.724Zm0-2.47a.972.972,0,1,0,.972.972A.973.973,0,0,0,159.346,150.255Z",
    transform: "translate(-157.848 -149.729)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(5.312 17.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M167.087,143.513A1.308,1.308,0,1,1,168.4,142.2,1.309,1.309,0,0,1,167.087,143.513Zm0-2.09a.782.782,0,1,0,.783.782A.783.783,0,0,0,167.087,141.423Z",
    transform: "translate(-165.779 -140.897)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(0 18.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M157.6,145.04a.968.968,0,1,1,.968-.968A.97.97,0,0,1,157.6,145.04Zm0-1.411a.443.443,0,1,0,.443.443A.443.443,0,0,0,157.6,143.629Z",
    transform: "translate(-156.633 -143.103)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(102.89 4.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M335.949,126.165h0a.263.263,0,0,1-.228-.132l-1.9-3.284a.263.263,0,0,1,0-.263l1.9-3.285a.263.263,0,0,1,.228-.131h0a.263.263,0,0,1,.228.131l1.9,3.285a.26.26,0,0,1,0,.263l-1.9,3.285A.264.264,0,0,1,335.949,126.165Zm-1.594-3.548,1.594,2.76,1.6-2.76-1.6-2.759Z",
    transform: "translate(-333.788 -119.07)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(99.063 4.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M328.7,120.634a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,328.7,120.634Zm0-2.47a.972.972,0,1,0,.972.972A.973.973,0,0,0,328.7,118.165Z",
    transform: "translate(-327.199 -117.639)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(103.669 0.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M336.438,114.529a1.308,1.308,0,1,1,1.309-1.309A1.309,1.309,0,0,1,336.438,114.529Zm0-2.091a.783.783,0,1,0,.783.782A.784.784,0,0,0,336.438,112.439Z",
    transform: "translate(-335.13 -111.913)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(99.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M329.079,112.635a.968.968,0,1,1,.969-.968A.969.969,0,0,1,329.079,112.635Zm0-1.411a.443.443,0,1,0,.443.443A.443.443,0,0,0,329.079,111.224Z",
    transform: "translate(-328.111 -110.698)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(141.922 123.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M403.736,331.72h0a.263.263,0,0,1-.228-.131l-2.48-4.293a.263.263,0,0,1,0-.263l2.48-4.293a.263.263,0,0,1,.228-.131h0a.263.263,0,0,1,.228.131l2.486,4.293a.265.265,0,0,1,0,.264l-2.486,4.293A.262.262,0,0,1,403.736,331.72Zm-2.176-4.556,2.177,3.768,2.181-3.768-2.181-3.768Z",
    transform: "translate(-400.993 -322.609)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(149.25 131.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M415.109,340.317a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,415.109,340.317Zm0-2.47a.972.972,0,1,0,.972.972A.973.973,0,0,0,415.109,337.848Z",
    transform: "translate(-413.611 -337.322)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(141.012 118.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M400.735,318.068a1.308,1.308,0,1,1,1.309-1.307A1.309,1.309,0,0,1,400.735,318.068Zm0-2.09a.782.782,0,1,0,.782.783A.784.784,0,0,0,400.735,315.978Z",
    transform: "translate(-399.427 -315.452)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(148.811 124.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M413.823,327.051a.968.968,0,1,1,.969-.968A.969.969,0,0,1,413.823,327.051Zm0-1.411a.443.443,0,1,0,.443.443A.443.443,0,0,0,413.823,325.64Z",
    transform: "translate(-412.855 -325.114)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(148.256 115.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M413.721,315.685h0a.263.263,0,0,1-.228-.131l-1.558-2.7a.263.263,0,0,1,0-.263l1.558-2.7a.264.264,0,0,1,.228-.131h0a.263.263,0,0,1,.228.131l1.561,2.7a.261.261,0,0,1,0,.264l-1.561,2.7A.263.263,0,0,1,413.721,315.685Zm-1.254-2.959,1.254,2.17,1.257-2.17-1.257-2.171Z",
    transform: "translate(-411.9 -309.767)",
    fill: "#25292b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(135.625 129.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M391.121,335.939a.968.968,0,1,1,.969-.968A.97.97,0,0,1,391.121,335.939Zm0-1.411a.443.443,0,1,0,.443.443A.443.443,0,0,0,391.121,334.528Z",
    transform: "translate(-390.152 -334.002)",
    fill: "#25292b"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(31.018 51.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(0 105.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(38.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M136.256,249.794s4.051,95.715,3.687,111.457H119.115L108.448,250.6Z",
    transform: "translate(-108.448 -249.794)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(0 0.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M60.706,251.311l-2.8,51.238L43,361.641H65.335l22.471-59.335,9.548-51.582Z",
    transform: "translate(-43.001 -250.724)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(43.059 3.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M117.734,307.858l-.594-.121c3.405-16.754,6.264-33.861,8.5-50.845l.032-.242,7.1-.613.052.6-6.616.57C123.977,274.13,121.127,291.169,117.734,307.858Z",
    transform: "translate(-117.14 -256.037)",
    fill: "#dfdedc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(1.714 111.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M45.952,441.8H63.7l4.686,4.139s13.887-.392,13.887,9.764H45.952Z",
    transform: "translate(-45.952 -441.804)",
    fill: "#9169df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(2.699 123.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M47.889,463.283h.064l34.163-.128a.242.242,0,0,0,0-.483h0l-34.226.128a.242.242,0,0,0,0,.483Z",
    transform: "translate(-47.647 -462.671)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(10.364 108.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M63,445.423c-1.242-.132-2-.623-2.134-1.381-.174-.981.8-1.684,1.679-1.988a8.822,8.822,0,0,1,8.238,1.454,13.763,13.763,0,0,1,3.287-5.548,3.581,3.581,0,0,1,1.809-1.149,1.62,1.62,0,0,1,1.9,1.054,2.246,2.246,0,0,1-.871,1.971,38.85,38.85,0,0,1-5.487,4.64.244.244,0,0,1-.233.024.235.235,0,0,1-.088.052,19.394,19.394,0,0,1-8.1.871Zm7.668-1.383a8.325,8.325,0,0,0-7.966-1.528c-.566.195-1.489.718-1.361,1.447s1.239.934,1.709.983a18.944,18.944,0,0,0,7.7-.783A.247.247,0,0,1,70.667,444.04Zm5.3-6.754a3.156,3.156,0,0,0-1.554,1.012,13.281,13.281,0,0,0-3.231,5.554c.041.037.082.075.123.114a38.327,38.327,0,0,0,5.256-4.469c.415-.422.874-.977.745-1.52a1.089,1.089,0,0,0-1.1-.713A1.215,1.215,0,0,0,75.97,437.286Z",
    transform: "translate(-60.845 -436.781)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(50.297 111.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M129.6,441.554h17.746l4.686,4.139s13.887-.392,13.887,9.764H129.6Z",
    transform: "translate(-129.602 -441.554)",
    fill: "#9169df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(51.282 123.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M131.539,463.032h.064l34.162-.128a.242.242,0,0,0,0-.483h0l-34.226.128a.242.242,0,0,0,0,.483Z",
    transform: "translate(-131.297 -462.421)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(58.946 108.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M146.648,445.172c-1.242-.132-2-.623-2.134-1.381-.174-.981.8-1.684,1.68-1.988a8.821,8.821,0,0,1,8.237,1.454,13.775,13.775,0,0,1,3.287-5.548,3.576,3.576,0,0,1,1.809-1.149,1.62,1.62,0,0,1,1.9,1.053,2.247,2.247,0,0,1-.87,1.971,38.85,38.85,0,0,1-5.488,4.64.243.243,0,0,1-.233.024.238.238,0,0,1-.088.052,19.4,19.4,0,0,1-8.1.871Zm7.669-1.383a8.326,8.326,0,0,0-7.965-1.528c-.566.195-1.49.718-1.361,1.447s1.238.934,1.709.984a18.944,18.944,0,0,0,7.7-.784A.242.242,0,0,1,154.317,443.789Zm5.3-6.754a3.161,3.161,0,0,0-1.555,1.012,13.287,13.287,0,0,0-3.232,5.554c.042.037.082.076.123.114a38.327,38.327,0,0,0,5.256-4.468c.415-.423.874-.977.745-1.52a1.09,1.09,0,0,0-1.1-.713A1.26,1.26,0,0,0,159.619,437.035Z",
    transform: "translate(-144.494 -436.531)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(4.589 33.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M109.28,174.982l2.852,22.494-2.8,11.465-8.665-10.925L88.238,208.941,64.019,198.6l.29-9.415a11.17,11.17,0,0,1-13.4-11.383l2.975-34.7c.192-4.844,3.748-12.079,8.412-13.385l15.969-4.725,13.91,2.544,9.455,2.9a11.165,11.165,0,0,1,7.788,9.194l2.765,20.676,13.027,3.369.482,11.3Z",
    transform: "translate(-50.902 -124.994)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(17.455 22.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M81.246,187.564h-.03a.292.292,0,0,1-.26-.319l2.368-23.034a.29.29,0,1,1,.578.059L81.535,187.3A.29.29,0,0,1,81.246,187.564Z",
    transform: "translate(-80.956 -163.95)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(10.028 42.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M72.442,219.6a.29.29,0,0,1-.088-.567l28.555-9.064-3.32-11.855-29.079,5.121a.29.29,0,1,1-.1-.571L97.747,197.5a.288.288,0,0,1,.33.208l3.467,12.378a.29.29,0,0,1-.192.355l-28.822,9.149A.288.288,0,0,1,72.442,219.6Z",
    transform: "translate(-68.168 -197.493)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(51.899 18.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M142.7,176.419a.29.29,0,0,1-.288-.257l-2.152-18.191a.29.29,0,0,1,.577-.068l2.152,18.191a.29.29,0,0,1-.254.322Z",
    transform: "translate(-140.261 -157.647)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(26.146 0.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M110.123,139.092a.29.29,0,0,1-.176-.06l-5.172-3.958a3.482,3.482,0,0,0-3.406,3.183.289.289,0,0,1-.2.228.286.286,0,0,1-.293-.07c-.054-.053-5.39-5.42-4.929-12.281a.3.3,0,0,1,.309-.27.291.291,0,0,1,.271.31c-.372,5.541,3.207,10.088,4.388,11.428a4.087,4.087,0,0,1,3.969-3.108.291.291,0,0,1,.166.06l5.249,4.017a.29.29,0,0,1-.177.521Z",
    transform: "translate(-95.92 -125.865)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(41.458 2.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M122.575,140.762l-.043,0a.291.291,0,0,1-.245-.33l.616-4.2a.288.288,0,0,1,.114-.191.294.294,0,0,1,.216-.054,4.913,4.913,0,0,1,2,.79c-.069-1.576-.469-4.972-2.606-6.4a.29.29,0,1,1,.322-.483c3.087,2.059,2.884,7.5,2.873,7.736a.29.29,0,0,1-.247.274.293.293,0,0,1-.317-.189c-.22-.614-1.221-.962-1.827-1.1l-.572,3.9A.291.291,0,0,1,122.575,140.762Z",
    transform: "translate(-122.284 -129.848)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(40.217 36.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M150.94,191.134l-8.288,1.016,2.3,1.795a1.934,1.934,0,0,1-1.191,3.462c-.058,0-.122,0-.18-.006a1.933,1.933,0,0,1-1.829,2.585,2,2,0,0,1-.61-.1,1.941,1.941,0,0,1-3,2.224l-1.742-1.359-.232.348c-4.036,5.03-9.084,2.991-9.084,2.991l-3.955,1.144-2.985-10.39,8.009-1.737,6.755-4.455a5.03,5.03,0,0,1,2.765-.831H150.94Z",
    transform: "translate(-120.147 -187.824)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(17.306 8.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M153.633,206.668a.289.289,0,0,1-.184-.066l-3.4-2.78a.29.29,0,0,1,.368-.45l3.4,2.78a.29.29,0,0,1-.184.515Z",
    transform: "translate(-149.945 -203.308)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(19.688 6.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M157.792,202.318a.288.288,0,0,1-.185-.067l-3.457-2.877a.29.29,0,0,1,.372-.446l3.456,2.877a.29.29,0,0,1-.186.513Z",
    transform: "translate(-154.045 -198.86)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(59.257 19.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M190.993,163.016,173.819,193.4a2.519,2.519,0,0,1-2.2,1.278H155.449a2.518,2.518,0,0,1-2.19-3.758l17.174-30.375a2.516,2.516,0,0,1,2.19-1.278H188.8A2.514,2.514,0,0,1,190.993,163.016Z",
    transform: "translate(-152.93 -159.264)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(78.225 36.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M197.349,191.584a1.822,1.822,0,0,1-1.324.97,2.16,2.16,0,0,1-1.754,3.671,2.157,2.157,0,0,1-1.493,3.63,2.444,2.444,0,0,1,.244.453,2.013,2.013,0,0,1-.041,1.7,2.366,2.366,0,0,1-3.218.784l-2.726-1.3a2.7,2.7,0,0,1-1.284-1.376,2.034,2.034,0,0,1,.041-1.7,2.077,2.077,0,0,1,1.766-1.08,2.231,2.231,0,0,1-.308-.61,2.155,2.155,0,0,1,.128-1.649,2.178,2.178,0,0,1,2.149-1.167,2.081,2.081,0,0,1-.476-.807,2.129,2.129,0,0,1,.128-1.649,2.169,2.169,0,0,1,2.207-1.162,1.523,1.523,0,0,1-.11-.267,1.816,1.816,0,0,1,.11-1.4,1.839,1.839,0,0,1,2.474-.8l2.686,1.285a1.845,1.845,0,0,1,.8,2.474Z",
    transform: "translate(-185.589 -187.621)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(1.681 9.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M193.991,206.944a.288.288,0,0,1-.126-.029l-5.217-2.522a.29.29,0,1,1,.253-.523l5.217,2.522a.29.29,0,0,1-.127.552Z",
    transform: "translate(-188.483 -203.842)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(3.65 5.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M196.9,200.841a.285.285,0,0,1-.127-.03l-4.741-2.319a.29.29,0,1,1,.255-.522l4.741,2.319a.29.29,0,0,1-.128.551Z",
    transform: "translate(-191.873 -197.941)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(5.508 2.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M200,194.559a.285.285,0,0,1-.127-.03l-4.637-2.267a.29.29,0,1,1,.256-.522l4.636,2.267a.29.29,0,0,1-.128.551Z",
    transform: "translate(-195.073 -191.711)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(29.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(0 10.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M94.069,95.063c.631,2.564,2.213,4.178,4.593,3.881l-2.672,9.8,4.59,3.979,9.108,7.857.951-12.478a9.314,9.314,0,0,0,3.649-2.068c1.976-1.695,5.29-5.883,5.549-9.834l.519-7.794A48.418,48.418,0,0,1,109.7,86.659c-2.828-.734-4.9-1.414-4.9-1.414a4.211,4.211,0,0,1-.324,1.106,14.5,14.5,0,0,1-3.125,4.043l-.006.038c-.005-.005-.005-.011-.01-.011a.331.331,0,0,1-.044-.048,4.912,4.912,0,0,0-2.839-1.56,4.5,4.5,0,0,0-1.738.076C94.177,89.52,93.389,92.316,94.069,95.063Z",
    transform: "translate(-93.836 -85.245)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(22.701 18.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 1.425,
    cy: 1.288,
    rx: 1.425,
    ry: 1.288,
    transform: "matrix(0.066, -0.998, 0.998, 0.066, 0, 2.844)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(14.193 16.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 1.425,
    cy: 1.288,
    rx: 1.425,
    ry: 1.288,
    transform: "matrix(0.316, -0.949, 0.949, 0.316, 0, 2.704)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448",
    transform: "translate(22.984 16.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M133.661,95.833a3.054,3.054,0,0,1,2.836.718.4.4,0,0,1-.506.607,2.7,2.7,0,0,0-.232-.2c-.04-.03-.081-.059-.123-.087l-.014-.009-.066-.038a2.667,2.667,0,0,0-.275-.134c-.047-.02-.095-.037-.143-.055l-.023-.008-.08-.023a2.772,2.772,0,0,0-.3-.062c-.051-.008-.1-.013-.152-.018l-.076-.006H134.5a2.975,2.975,0,0,0-.3.013c-.051.005-.1.012-.152.02l-.076.013-.013,0-.015,0a.406.406,0,0,1-.509-.231A.4.4,0,0,1,133.661,95.833Z",
    transform: "translate(-133.41 -95.741)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    transform: "translate(14.907 14.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M122.7,94.082a.406.406,0,0,1-.559.021l-.012-.009-.011-.007-.064-.041c-.044-.026-.088-.052-.132-.076a2.866,2.866,0,0,0-.278-.128l-.006,0h0l-.073-.024c-.049-.015-.1-.028-.148-.041a2.611,2.611,0,0,0-.3-.056l-.083-.009h-.024c-.051,0-.1,0-.153,0a2.543,2.543,0,0,0-.3.02l-.076.01-.016,0c-.049.01-.1.021-.146.034a2.7,2.7,0,0,0-.29.1.4.4,0,1,1-.238-.754,3.054,3.054,0,0,1,2.9.408A.4.4,0,0,1,122.7,94.082Z",
    transform: "translate(-119.504 -92.917)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    transform: "translate(13.582 23.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M118.781,111.756a2.5,2.5,0,0,1-1.421-1.411,2.981,2.981,0,0,1,.142-2.118.25.25,0,0,1,.323-.12l4.476,1.941a.249.249,0,0,1,.125.338,3.015,3.015,0,0,1-2.445,1.648A2.923,2.923,0,0,1,118.781,111.756Zm-.916-3.089a2.358,2.358,0,0,0-.035,1.507,2.017,2.017,0,0,0,1.156,1.126,2.178,2.178,0,0,0,2.862-.907Z",
    transform: "translate(-117.221 -108.087)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(1.908 14.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M99.482,101.173a.3.3,0,0,1-.16-.045,2.588,2.588,0,0,1,.87-4.756,2.116,2.116,0,0,0-.123-1.56,1.452,1.452,0,0,0-1.372-.788,1.087,1.087,0,0,0-.962,1.052.307.307,0,0,1-.288.325.3.3,0,0,1-.325-.288,1.685,1.685,0,0,1,1.51-1.7,2.069,2.069,0,0,1,1.978,1.108,2.741,2.741,0,0,1,.1,2.23.305.305,0,0,1-.256.2,1.976,1.976,0,0,0-.817,3.651.307.307,0,0,1-.16.57Z",
    transform: "translate(-97.121 -93.404)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(11.146 30.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M117.255,122.734a2.558,2.558,0,0,1-.677-.081c-1.439-.4-3.4-2.711-3.479-2.809a.307.307,0,1,1,.469-.4c.019.023,1.918,2.264,3.174,2.614,1.029.286,3.169-.519,3.906-.854a.307.307,0,0,1,.254.559A11.045,11.045,0,0,1,117.255,122.734Z",
    transform: "translate(-113.027 -119.339)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(5.687 11.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(4.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M116.9,98.037a5.021,5.021,0,1,1,4.66-3.135h0A5.03,5.03,0,0,1,116.9,98.037Zm.006-9.431a4.414,4.414,0,1,0,1.656.326A4.405,4.405,0,0,0,116.91,88.606Z",
    transform: "translate(-111.887 -87.992)",
    fill: "#9169df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    transform: "translate(15.811 3.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M135.866,103.447a5.021,5.021,0,1,1,4.66-3.135h0A5.03,5.03,0,0,1,135.866,103.447Zm.006-9.431a4.414,4.414,0,1,0,1.656.326A4.4,4.4,0,0,0,135.872,94.015Z",
    transform: "translate(-130.851 -93.401)",
    fill: "#9169df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461",
    transform: "translate(0 0.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_750",
    "data-name": "Rectangle 750",
    width: 0.614,
    height: 6.004,
    transform: "translate(0 0.53) rotate(-59.789)",
    fill: "#9169df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    transform: "translate(14.069 6.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_751",
    "data-name": "Rectangle 751",
    width: 0.614,
    height: 2.131,
    transform: "translate(0 0.564) rotate(-66.804)",
    fill: "#9169df"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(2.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M98.394,81.482a4.5,4.5,0,0,1,1.738-.076,4.911,4.911,0,0,1,2.839,1.56l.06.021a14.5,14.5,0,0,0,3.125-4.043,4.21,4.21,0,0,0,.324-1.106s2.068.68,4.9,1.414A48.418,48.418,0,0,0,122.031,81c2.062.016,3.745-.318,4.556-1.242,3.665-4.189.993-8.507-3.05-8.1-3.876.394-6.494.324-10.725-2.348s-8.685-2.23-9.986,1.2C102.825,70.509,95.835,70.725,98.394,81.482Z",
    transform: "translate(-97.831 -67.579)",
    fill: "#25292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(18.002 17.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M128.968,105.8a.324.324,0,0,1-.1-.015l-3.829-1.264a.307.307,0,1,1,.192-.583l3.391,1.119-.5-6.393a.307.307,0,1,1,.612-.048l.533,6.853a.306.306,0,0,1-.306.33Z",
    transform: "translate(-124.831 -98.334)",
    fill: "#25292b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(117.248 73.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508",
    transform: "translate(0.102 65.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M264.73,266.6H194.507a2.863,2.863,0,0,1-2.86-2.86v-42.5a2.863,2.863,0,0,1,2.86-2.859H264.73a2.863,2.863,0,0,1,2.86,2.859v42.5A2.863,2.863,0,0,1,264.73,266.6Zm-70.223-47.788a2.434,2.434,0,0,0-2.431,2.431v42.5a2.434,2.434,0,0,0,2.431,2.431H264.73a2.434,2.434,0,0,0,2.431-2.431v-42.5a2.434,2.434,0,0,0-2.431-2.431Z",
    transform: "translate(-191.647 -218.386)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(0.214 0.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M3,0H73.514a2,2,0,0,1,2,2V5.487H0V3A3,3,0,0,1,3,0Z",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(5.005 7.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_753",
    "data-name": "Rectangle 753",
    width: 11.063,
    height: 11.063,
    transform: "translate(11.063 11.063) rotate(-180)",
    fill: "#dfdedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(5.005 20.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_754",
    "data-name": "Rectangle 754",
    width: 11.063,
    height: 11.063,
    transform: "translate(11.063 11.063) rotate(-180)",
    fill: "#dfdedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(5.005 33.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_755",
    "data-name": "Rectangle 755",
    width: 11.063,
    height: 11.063,
    transform: "translate(11.063 11.063) rotate(-180)",
    fill: "#dfdedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480",
    transform: "translate(5.511 8.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M205.091,241.185l-3.955-3.955,2.014-2.014,1.941,1.941,4.083-4.083,2.014,2.014Z",
    transform: "translate(-201.136 -233.074)",
    fill: "#9169df"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    transform: "translate(5.511 22.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M205.091,264.9l-3.955-3.955,2.014-2.014,1.941,1.941,4.083-4.083,2.014,2.014Z",
    transform: "translate(-201.136 -256.793)",
    fill: "#9169df"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(5.511 34.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M205.091,286.62l-3.955-3.955,2.014-2.014,1.941,1.941,4.083-4.083,2.014,2.014Z",
    transform: "translate(-201.136 -278.508)",
    fill: "#9169df"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    transform: "translate(17.922 8.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_756",
    "data-name": "Rectangle 756",
    width: 53.086,
    height: 2.187,
    transform: "translate(53.086 2.187) rotate(-180)",
    fill: "#dfdedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(0 4.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_757",
    "data-name": "Rectangle 757",
    width: 53.086,
    height: 2.187,
    transform: "translate(53.086 2.187) rotate(-180)",
    fill: "#dfdedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(0 8.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_758",
    "data-name": "Rectangle 758",
    width: 23.885,
    height: 2.187,
    transform: "translate(23.885 2.187) rotate(-180)",
    fill: "#dfdedc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(17.922 21.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_759",
    "data-name": "Rectangle 759",
    width: 53.086,
    height: 2.187,
    transform: "translate(53.086 2.187) rotate(-180)",
    fill: "#dfdedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(0 4.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_760",
    "data-name": "Rectangle 760",
    width: 53.086,
    height: 2.187,
    transform: "translate(53.086 2.187) rotate(-180)",
    fill: "#dfdedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    transform: "translate(0 8.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_761",
    "data-name": "Rectangle 761",
    width: 23.885,
    height: 2.187,
    transform: "translate(23.885 2.187) rotate(-180)",
    fill: "#dfdedc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    transform: "translate(17.922 34.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_762",
    "data-name": "Rectangle 762",
    width: 53.086,
    height: 2.187,
    transform: "translate(53.086 2.187) rotate(-180)",
    fill: "#dfdedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    transform: "translate(0 4.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_763",
    "data-name": "Rectangle 763",
    width: 53.086,
    height: 2.187,
    transform: "translate(53.086 2.187) rotate(-180)",
    fill: "#dfdedc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(0 8.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    "data-name": "Rectangle 764",
    width: 23.885,
    height: 2.187,
    transform: "translate(23.885 2.187) rotate(-180)",
    fill: "#dfdedc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530",
    transform: "translate(19.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509",
    transform: "translate(63.49 52.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M388.879,231.88l-3.8,11.385c-5.209,15.57-22.419,19.772-34.217,8.354l-8.623-8.35c-14.4-13.935-10.061-39.687,7.4-43.951l12.428-3.034C379.519,192.022,395.233,212.879,388.879,231.88Z",
    transform: "translate(-333.587 -195.724)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(68.854 49.796)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 16.9,
    cy: 6.63,
    rx: 16.9,
    ry: 6.63,
    transform: "translate(0 8.017) rotate(-13.721)",
    fill: "#318dbe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511",
    transform: "translate(55.813 18.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M375.779,161.835c0,12.641-12.4,16.815-27.7,16.815s-27.705-4.174-27.705-16.815,12.4-24.5,27.705-24.5S375.779,149.194,375.779,161.835Z",
    transform: "translate(-320.369 -137.332)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512",
    transform: "translate(55.812 26.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M336.222,174.77s-12.309-.15-15.838-6.778c-.011-.226-.016-.458-.016-.694,0-6.289,3.078-12.39,8.054-16.931H359.4S370.32,174.77,336.222,174.77Z",
    transform: "translate(-320.368 -150.367)",
    fill: "#8ad7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    transform: "translate(59.751 30.579)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 4.105,
    cy: 4.664,
    rx: 4.105,
    ry: 4.664,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514",
    transform: "translate(74.124 30.579)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 4.105,
    cy: 4.664,
    rx: 4.105,
    ry: 4.664,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515",
    transform: "translate(65.743 41.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M341.35,179.376a3.581,3.581,0,0,1-3.882-3.478.189.189,0,0,1,.188-.189h0a.189.189,0,0,1,.189.187,3.529,3.529,0,0,0,7.007,0,.189.189,0,0,1,.189-.187h0a.189.189,0,0,1,.188.189A3.581,3.581,0,0,1,341.35,179.376Z",
    transform: "translate(-337.468 -175.708)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    transform: "translate(97.951 23.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M396.646,178.313a.191.191,0,0,1-.089-.023.188.188,0,0,1-.077-.256,28.244,28.244,0,0,0-3.513-31.871.189.189,0,0,1,.286-.247,28.621,28.621,0,0,1,3.559,32.3A.189.189,0,0,1,396.646,178.313Z",
    transform: "translate(-392.922 -145.85)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517",
    transform: "translate(84.298 6.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M369.6,131.275a.192.192,0,0,1-.1-.031.189.189,0,0,1-.053-.262,17.685,17.685,0,0,0,2.089-14.885.189.189,0,0,1,.36-.113,18.065,18.065,0,0,1-2.133,15.207A.189.189,0,0,1,369.6,131.275Z",
    transform: "translate(-369.415 -115.851)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518",
    transform: "translate(81.312)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 5.272,
    cy: 5.272,
    r: 5.272,
    fill: "#9169df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519",
    transform: "translate(98.735 65.53)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 8.026,
    cy: 10.17,
    rx: 8.026,
    ry: 10.17,
    fill: "#8ad7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521",
    transform: "translate(56.781 69.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M344.656,246.629a44.579,44.579,0,0,1-19.949-4.7,4.846,4.846,0,1,1,4.352-8.66,34.557,34.557,0,0,0,40.27-6.76,4.846,4.846,0,0,1,6.942,6.764A44.57,44.57,0,0,1,351.9,246.029,43.828,43.828,0,0,1,344.656,246.629Z",
    transform: "translate(-322.036 -225.042)",
    fill: "#318dbe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(0 55.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M233.842,200.841a11.4,11.4,0,0,1,13.078,12.941l-.076.508a2.549,2.549,0,1,1-5.042-.754l.076-.508a6.3,6.3,0,1,0-12.461-1.863l-.076.508a2.549,2.549,0,0,1-5.042-.754l.076-.508A11.419,11.419,0,0,1,233.842,200.841Z",
    transform: "translate(-224.271 -200.697)",
    fill: "#9169df"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529",
    transform: "translate(45.389 66.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M318.542,230.77a10.558,10.558,0,0,1-14.1,9.566l-.448-.16a2.361,2.361,0,0,1,1.588-4.447l.448.16a5.835,5.835,0,1,0,3.927-10.99l-.448-.16a2.361,2.361,0,1,1,1.589-4.447l.448.16A10.576,10.576,0,0,1,318.542,230.77Z",
    transform: "translate(-302.422 -220.153)",
    fill: "#8ad7ff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(0 117.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531",
    transform: "translate(4.7 12.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M3,0H30.421a3,3,0,0,1,3,3V30.421a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z",
    fill: "#9169df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532",
    transform: "translate(0.316 0.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M3,0H109.426a2,2,0,0,1,2,2V8.1H0V3A3,3,0,0,1,3,0Z",
    fill: "#9169df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M300.568,378.381H194.433a2.964,2.964,0,0,1-2.961-2.961V310.2a2.965,2.965,0,0,1,2.961-2.962H300.568a2.965,2.965,0,0,1,2.962,2.962V375.42A2.965,2.965,0,0,1,300.568,378.381ZM194.433,307.867a2.332,2.332,0,0,0-2.33,2.33V375.42a2.332,2.332,0,0,0,2.33,2.329H300.568a2.332,2.332,0,0,0,2.33-2.329V310.2a2.332,2.332,0,0,0-2.33-2.33Z",
    transform: "translate(-191.472 -307.235)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534",
    transform: "translate(98.673 3.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M370.369,313.747a1.309,1.309,0,0,1-1.313,1.313H362.68a1.315,1.315,0,0,1-1.313-1.313,1.338,1.338,0,0,1,.383-.929,1.323,1.323,0,0,1,.929-.383h6.377A1.311,1.311,0,0,1,370.369,313.747Z",
    transform: "translate(-361.367 -312.434)",
    fill: "#dfdedc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535",
    transform: "translate(88.068 3.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M352.109,313.747a1.319,1.319,0,0,1-1.313,1.313H344.42a1.313,1.313,0,1,1,0-2.625H350.8A1.315,1.315,0,0,1,352.109,313.747Z",
    transform: "translate(-343.107 -312.434)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    transform: "translate(77.282 3.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M333.538,313.747a1.319,1.319,0,0,1-1.313,1.313h-6.377a1.313,1.313,0,1,1,0-2.625h6.377A1.315,1.315,0,0,1,333.538,313.747Z",
    transform: "translate(-324.536 -312.434)",
    fill: "#ffa727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539",
    transform: "translate(9.938 20.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M210.833,355.789l-8.426-8.427,4.026-4.026,4.4,4.4,10.919-10.919,4.026,4.026Z",
    transform: "translate(-202.407 -336.817)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    transform: "translate(4.7 50.855)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    "data-name": "Rectangle 767",
    width: 101.898,
    height: 1.931,
    rx: 0.965,
    fill: "#dfdedc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541",
    transform: "translate(4.809 57.682)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    "data-name": "Rectangle 768",
    width: 101.898,
    height: 1.931,
    rx: 0.965,
    fill: "#dfdedc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    transform: "translate(4.755 64.095)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    "data-name": "Rectangle 769",
    width: 71.546,
    height: 1.931,
    rx: 0.965,
    fill: "#dfdedc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(44.097 10.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(2.417 2.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M309.144,356.281a6.249,6.249,0,0,1-6.242-6.242V336.7a5.049,5.049,0,1,0-10.1,0v10.919a5.5,5.5,0,0,1-5.5,5.5h-.195a5.5,5.5,0,0,1-5.5-5.5V335.541a4.562,4.562,0,1,0-9.124,0v22.615a.467.467,0,1,1-.934,0V335.541a5.5,5.5,0,1,1,10.991,0v12.077a4.567,4.567,0,0,0,4.562,4.562h.195a4.567,4.567,0,0,0,4.563-4.562V336.7a5.982,5.982,0,1,1,11.964,0v13.34a5.308,5.308,0,1,0,10.617,0v-3.21a6.069,6.069,0,1,1,12.138,0v13.123a.467.467,0,1,1-.933,0V346.829a5.135,5.135,0,0,0-10.271,0v3.21A6.249,6.249,0,0,1,309.144,356.281Z",
    transform: "translate(-271.56 -330.045)",
    fill: "#dfdedc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547",
    transform: "translate(4.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 2.862,
    cy: 2.862,
    r: 2.862,
    fill: "#9169df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    transform: "translate(20.073 11.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 2.862,
    cy: 2.862,
    r: 2.862,
    fill: "#9169df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551",
    transform: "translate(31.832 5.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 2.862,
    cy: 2.862,
    r: 2.862,
    fill: "#9169df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553",
    transform: "translate(36.857 25.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 2.862,
    cy: 2.862,
    r: 2.862,
    fill: "#9169df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(54.118 28.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 2.862,
    cy: 2.862,
    r: 2.862,
    fill: "#9169df"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(0 27.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 2.862,
    cy: 2.862,
    r: 2.862,
    fill: "#9169df"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    transform: "translate(119.852 51.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M196.245,120.025a.29.29,0,0,1-.29-.29V116.25a.29.29,0,1,1,.581,0v3.485A.291.291,0,0,1,196.245,120.025Zm57.582-3.429a.29.29,0,0,1-.01-.58,7.676,7.676,0,0,0,3.227-.829.29.29,0,0,1,.263.518,8.254,8.254,0,0,1-3.47.891Zm-3.438-.419a.289.289,0,0,1-.093-.015,8.384,8.384,0,0,1-3.065-1.853.29.29,0,1,1,.4-.42,7.8,7.8,0,0,0,2.851,1.724.29.29,0,0,1-.093.565Zm9.462-2.629a.291.291,0,0,1-.228-.471,7.664,7.664,0,0,0,1.46-3,.291.291,0,0,1,.565.136,8.255,8.255,0,0,1-1.569,3.22A.29.29,0,0,1,259.852,113.549Zm-63.606-.493a.29.29,0,0,1-.29-.29v-3.485a.29.29,0,1,1,.581,0v3.485A.291.291,0,0,1,196.245,113.056Zm49.248-1.529a.29.29,0,0,1-.27-.183,8.3,8.3,0,0,1-.587-3.078v-.443a.29.29,0,1,1,.581,0v.443a7.71,7.71,0,0,0,.546,2.863.29.29,0,0,1-.27.4Zm-24.842-.6h-.271a8.344,8.344,0,0,1-2.5-.38.291.291,0,0,1,.174-.555,7.759,7.759,0,0,0,2.323.354h.271q.373,0,.738-.034a.29.29,0,0,1,.054.578Q221.052,110.93,220.651,110.93Zm4.055-1.095a.291.291,0,0,1-.147-.541,7.829,7.829,0,0,0,2.45-2.259.291.291,0,0,1,.476.333,8.431,8.431,0,0,1-2.633,2.428A.285.285,0,0,1,224.706,109.835Zm-9.733-.993a.29.29,0,0,1-.2-.076,8.409,8.409,0,0,1-2.075-2.92.291.291,0,1,1,.535-.227,7.812,7.812,0,0,0,1.93,2.717.29.29,0,0,1-.2.505Zm46.615-1.867a.29.29,0,0,1-.29-.29V103.2a.29.29,0,0,1,.581,0v3.485A.291.291,0,0,1,261.588,106.975Zm-65.343-.889a.29.29,0,0,1-.29-.29v-3.485a.29.29,0,0,1,.581,0V105.8A.291.291,0,0,1,196.245,106.086Zm48.682-1.457a.29.29,0,0,1-.29-.29v-3.485a.29.29,0,1,1,.581,0v3.485A.29.29,0,0,1,244.927,104.629Zm-16.354-.331a.308.308,0,0,1-.051,0,.291.291,0,0,1-.235-.337,7.751,7.751,0,0,0,.119-1.363v-2.064a.29.29,0,1,1,.581,0v2.063a8.355,8.355,0,0,1-.128,1.465A.29.29,0,0,1,228.573,104.3Zm-16.237-1.673a.29.29,0,0,1-.29-.29V98.85a.29.29,0,0,1,.581,0v3.485A.29.29,0,0,1,212.336,102.625Zm49.253-2.619a.29.29,0,0,1-.29-.29V96.231a.29.29,0,0,1,.581,0v3.485A.291.291,0,0,1,261.588,100.006Zm-65.343-.889a.29.29,0,0,1-.29-.29V95.342a.29.29,0,1,1,.581,0v3.485A.291.291,0,0,1,196.245,99.117Zm48.682-1.457a.29.29,0,0,1-.29-.29V93.885a.29.29,0,0,1,.581,0v3.485A.29.29,0,0,1,244.927,97.66ZM228.7,97.337a.29.29,0,0,1-.29-.29V93.562a.29.29,0,1,1,.581,0v3.485A.29.29,0,0,1,228.7,97.337Zm-16.36-1.681a.29.29,0,0,1-.29-.29V91.88a.29.29,0,1,1,.581,0v3.485A.29.29,0,0,1,212.336,95.656Zm49.253-2.619a.29.29,0,0,1-.29-.29V89.261a.29.29,0,0,1,.581,0v3.485A.291.291,0,0,1,261.588,93.036Zm-65.343-.889a.291.291,0,0,1-.29-.29V88.372a.29.29,0,0,1,.581,0v3.485A.291.291,0,0,1,196.245,92.148Zm48.682-1.457a.29.29,0,0,1-.29-.29V87.27c0-.114,0-.229-.008-.342a.29.29,0,1,1,.58-.025q.008.182.008.367V90.4A.29.29,0,0,1,244.927,90.69ZM228.7,90.367a.29.29,0,0,1-.29-.29V87.27q0-.355.03-.7a.29.29,0,1,1,.578.049c-.018.215-.027.433-.027.652v2.807A.29.29,0,0,1,228.7,90.367Zm-16.36-1.681a.29.29,0,0,1-.29-.29V84.911a.29.29,0,1,1,.581,0V88.4A.29.29,0,0,1,212.336,88.686Zm49.253-2.619a.29.29,0,0,1-.29-.29V82.292a.29.29,0,0,1,.581,0v3.485A.291.291,0,0,1,261.588,86.067Zm-65.343-.889a.29.29,0,0,1-.29-.29V81.4a.29.29,0,0,1,.581,0v3.485A.291.291,0,0,1,196.245,85.178Zm99.967-.078a.289.289,0,0,1-.246-.135,4.094,4.094,0,0,0-2.6-1.807.291.291,0,1,1,.12-.569,4.677,4.677,0,0,1,2.97,2.065.291.291,0,0,1-.245.446ZM244.03,83.866a.291.291,0,0,1-.258-.157,7.828,7.828,0,0,0-2.131-2.562.29.29,0,0,1,.357-.458,8.416,8.416,0,0,1,2.29,2.753.29.29,0,0,1-.258.424Zm-14.283-.285a.29.29,0,0,1-.253-.434,8.427,8.427,0,0,1,2.4-2.659.29.29,0,1,1,.338.472A7.837,7.837,0,0,0,230,83.435.291.291,0,0,1,229.747,83.582Zm60.2-.512h-3.485a.29.29,0,1,1,0-.581h3.485a.29.29,0,1,1,0,.581Zm-6.871-.684a.284.284,0,0,1-.12-.026,8.065,8.065,0,0,1-2.85-2.173.291.291,0,0,1,.447-.372A7.467,7.467,0,0,0,283.2,81.83a.291.291,0,0,1-.12.555Zm-70.743-.669a.29.29,0,0,1-.29-.29V80.118a7.805,7.805,0,0,0-.28-2.072.291.291,0,0,1,.2-.358.294.294,0,0,1,.358.2,8.383,8.383,0,0,1,.3,2.227v1.309A.29.29,0,0,1,212.336,81.717Zm26.364-2a.289.289,0,0,1-.066-.007,7.789,7.789,0,0,0-1.752-.2h-.141a7.862,7.862,0,0,0-1.447.134.29.29,0,0,1-.108-.57,8.374,8.374,0,0,1,1.555-.145h.141a8.383,8.383,0,0,1,1.883.213.29.29,0,0,1-.065.573Zm22.888-.624a.29.29,0,0,1-.29-.29V75.322a.29.29,0,0,1,.581,0v3.485A.291.291,0,0,1,261.588,79.1Zm-65.046-.861a.28.28,0,0,1-.078-.01.29.29,0,0,1-.2-.358,8.253,8.253,0,0,1,1.687-3.16.291.291,0,0,1,.442.378,7.68,7.68,0,0,0-1.569,2.939A.29.29,0,0,1,196.542,78.236Zm82.232-1.029a.291.291,0,0,1-.282-.221,8.065,8.065,0,0,1-.23-1.913,7.477,7.477,0,0,0-.162-1.55.29.29,0,1,1,.568-.121,8.034,8.034,0,0,1,.175,1.671,7.471,7.471,0,0,0,.213,1.774.291.291,0,0,1-.213.351A.284.284,0,0,1,278.774,77.207Zm-68.348-2a.289.289,0,0,1-.221-.1,7.833,7.833,0,0,0-2.65-2.021.291.291,0,1,1,.245-.527,8.425,8.425,0,0,1,2.848,2.172.29.29,0,0,1-.221.479Zm-9.5-2.106a.29.29,0,0,1-.122-.554,8.269,8.269,0,0,1,3.488-.763.3.3,0,0,1,.3.29.286.286,0,0,1-.285.29,7.7,7.7,0,0,0-3.255.709A.283.283,0,0,1,200.925,73.1Zm61.331-.876a.291.291,0,0,1-.265-.409,8.053,8.053,0,0,1,2.159-2.861.29.29,0,1,1,.374.444,7.468,7.468,0,0,0-2,2.654A.291.291,0,0,1,262.255,72.222Zm14.666-1.6a.289.289,0,0,1-.229-.112,7.484,7.484,0,0,0-2.58-2.1.29.29,0,1,1,.257-.521,8.072,8.072,0,0,1,2.781,2.26.29.29,0,0,1-.229.469Zm-9.51-2.733a.29.29,0,0,1-.07-.572,8.006,8.006,0,0,1,1.948-.24h1.558a.3.3,0,0,1,.306.29.278.278,0,0,1-.276.29h-1.587a7.426,7.426,0,0,0-1.807.222A.3.3,0,0,1,267.412,67.891Z",
    transform: "translate(-195.955 -67.079)",
    fill: "#25292b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    transform: "translate(31.141 2.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 9.735,
    cy: 9.735,
    r: 9.735,
    fill: "#9169df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    transform: "translate(0.977 4.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(0 0.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M256.449,89.169a.533.533,0,0,1-.334-.117l-4.657-3.719a.536.536,0,0,1,0-.837l4.6-3.672a.536.536,0,0,1,.669.838l-4.072,3.253,4.132,3.3a.536.536,0,0,1-.335.955Z",
    transform: "translate(-251.257 -80.705)",
    fill: "#dfdedc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(11.787 0.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M272.088,89.169a.536.536,0,0,1-.335-.955l4.132-3.3-4.073-3.253a.536.536,0,0,1,.669-.838l4.6,3.672a.536.536,0,0,1,0,.837l-4.657,3.719A.531.531,0,0,1,272.088,89.169Z",
    transform: "translate(-271.551 -80.705)",
    fill: "#dfdedc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(7.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M264.1,89.439a.525.525,0,0,1-.229-.019.536.536,0,0,1-.355-.67l2.881-9.368a.536.536,0,0,1,1.025.315l-2.882,9.368A.536.536,0,0,1,264.1,89.439Z",
    transform: "translate(-263.488 -79.003)",
    fill: "#dfdedc"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(27.69 52.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M259.011,165.971h1.5a8.489,8.489,0,0,0-.836-3.664l-1.355.654a6.947,6.947,0,0,0-1.927-2.413l.939-1.175a8.631,8.631,0,0,0-1.6-1.009,8.442,8.442,0,0,0-1.787-.622l-.333,1.465a6.968,6.968,0,0,0-3.087,0l-.333-1.466a8.454,8.454,0,0,0-1.787.622,8.646,8.646,0,0,0-1.6,1.009l.939,1.175a6.948,6.948,0,0,0-1.927,2.413l-1.355-.654a8.513,8.513,0,0,0-.835,3.664h1.505a6.925,6.925,0,0,0,.685,3.011l-1.355.654a8.5,8.5,0,0,0,2.343,2.934l.939-1.176a6.882,6.882,0,0,0,2.781,1.341L250.2,174.2a8.409,8.409,0,0,0,3.754,0l-.333-1.465a6.9,6.9,0,0,0,2.781-1.342l.939,1.176a8.488,8.488,0,0,0,2.343-2.934l-1.355-.654A6.909,6.909,0,0,0,259.011,165.971Zm-6.938,4.758a4.652,4.652,0,1,1,4.652-4.653A4.652,4.652,0,0,1,252.073,170.729Z",
    transform: "translate(-243.632 -157.742)",
    fill: "#9169df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(14.226 8.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M291.241,185.111h2.921a14.005,14.005,0,0,0-.16-2.034,13.321,13.321,0,0,0-.477-1.989,13.027,13.027,0,0,0-1.853-3.631l-2.36,1.717a10.11,10.11,0,0,0-5.048-3.669l.9-2.777a13.039,13.039,0,0,0-8.045,0l.9,2.777a10.107,10.107,0,0,0-5.049,3.671l-2.36-1.719a12.572,12.572,0,0,0-1.067,1.741,12.339,12.339,0,0,0-.784,1.889,13.115,13.115,0,0,0-.479,1.989,14.081,14.081,0,0,0-.159,2.034h2.92a10.047,10.047,0,0,0,1.928,5.936l-2.36,1.717a13.038,13.038,0,0,0,6.507,4.73l.9-2.776a10.14,10.14,0,0,0,6.242,0l.9,2.778a13.038,13.038,0,0,0,6.507-4.73l-2.36-1.717A10.043,10.043,0,0,0,291.241,185.111Zm-10.1,5.452a5.771,5.771,0,1,1,5.77-5.771A5.77,5.77,0,0,1,281.146,190.564Z",
    transform: "translate(-268.126 -172.093)",
    fill: "#9169df"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(17.644)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 3.455,
    cy: 3.455,
    r: 3.455,
    fill: "#9169df"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(14.416 281.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M287.831,465.153H14.649a.234.234,0,0,1,0-.469H287.831a.234.234,0,0,1,0,.469Z",
    transform: "translate(-14.416 -464.684)",
    fill: "#25292b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVl2);
export default __webpack_public_path__ + "static/media/vl2.20ac58d63c2643ee201acab273e45b31.svg";
export { ForwardRef as ReactComponent };